export class InvoiceApiError extends Error {
    constructor(message, {
        status = null,
        authenticationRequired = false,
        code = null,
        ignoredClassIds = [],
    } = {}) {
        super(message);
        this.name = 'InvoiceApiError';
        this.status = status;
        this.authenticationRequired = authenticationRequired;
        this.code = code;
        this.ignoredClassIds = ignoredClassIds;
    }
}

export function ensureActiveInvoiceSession(token, expiry, now = Date.now()) {
    const parsedExpiry = Number(expiry);
    if (!token || (expiry && Number.isFinite(parsedExpiry) && parsedExpiry <= now)) {
        throw new InvoiceApiError('Reikia prisijungti iš naujo.', {
            status: 401,
            authenticationRequired: true,
        });
    }
    return token;
}

async function responsePayload(response) {
    try {
        return await response.json();
    } catch (_error) {
        return {};
    }
}

export async function requestInvoiceJson(url, token, { fetchImpl = fetch, ...options } = {}) {
    const response = await fetchImpl(url, {
        method: 'GET',
        ...options,
        headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json',
            ...(options.headers || {}),
        },
    });
    const payload = await responsePayload(response);
    if (!response.ok) {
        throw new InvoiceApiError(
            payload.message || payload.detail || payload.error || 'Nepavyko gauti sąskaitos duomenų.',
            {
                status: response.status,
                authenticationRequired: response.status === 401,
                code: payload.code || null,
                ignoredClassIds: Array.isArray(payload.ignored_class_ids)
                    ? payload.ignored_class_ids
                    : [],
            },
        );
    }
    return payload;
}

export function clearInvoiceAuthentication(storage) {
    storage.removeItem('jwtToken');
    storage.removeItem('jwtExpiry');
}

export function buildSelectedClassQuotes(classes, selectedClassIds) {
    const selected = new Set(selectedClassIds.map((value) => Number(value)));
    return Object.fromEntries(
        classes
            .filter((item) => selected.has(Number(item.id)))
            .map((item) => [
                String(item.id),
                {
                    amount_due: Number(item.amount_due || 0).toFixed(2),
                    quote_fingerprint: item.quote_fingerprint,
                },
            ]),
    );
}

